import { render, staticRenderFns } from "./RiepilogoDay.vue?vue&type=template&id=60738bc8&"
import script from "./RiepilogoDay.vue?vue&type=script&lang=js&"
export * from "./RiepilogoDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports